import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 95vh;
`;
export const Container = styled.div`
  max-width: 290px;
`;

export const Text = styled.p`
  font-family: Poppins;
  text-align: center;
  color: #240055;

  a {
    color: #007bff;
    text-decoration: none;
  }
`;
